import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { map, takeUntil, tap } from 'rxjs/operators';

import {
  CustomResultOfGetWhiteMessageCalculationsDto,
  SendTypes,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { GetScheduledMessageByIdDto } from '../../../core/api/models/get-scheduled-message-by-id-dto';
import { GetScheduledMessageCalculationsDto } from '../../../core/api/models/get-scheduled-message-calculations-dto';
import { PhoneBookRecipientRequest } from '../../../core/api/models/phone-book-recipient-request';
import { PrivateNumbersService } from '../../../core/api/services/private-numbers.service';
import { SendDateTimeType } from '../../../core/enums/send-date-time-type.enum';
import { FormPageConfig } from '../../../core/models/form-page-config.model';
import { DialogService } from '../../../core/services/dialog.service';
import { AppDomService } from '../../../core/services/dom.service';
import { DynamicTabService } from '../../../core/services/dynamic-tab.service';
import { UtilityService } from '../../../core/services/utility.service';

import { PhonebookGlobalIndex } from '../../facility/phonebook/shared/phonebook-custom.model';
import { PhonebookStateService } from '../../facility/phonebook/shared/phonebook-state.service';
import { BaseSendSms, BaseSendSmsConfig } from '../../sending-system/base/base-send-sms/base-send-sms.component';
import { SendSmsConfirmationComponent } from '../../sending-system/send-sms-confirmation/send-sms-confirmation.component';
import { BaseFormPageComponent } from '../../shared/base/components/base-form-page.component';
import { CreateWhiteSmsCommand } from './../../../core/api/models/create-white-sms-command';
import { GetWhiteMessageCalculationsQuery } from './../../../core/api/models/get-white-message-calculations-query';
import { WhiteMessagesService } from './../../../core/api/services/white-messages.service';
import { PhonebookSelectorComponent } from "../../facility/phonebook/phonebook-selector/phonebook-selector.component";
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { BaseSendSmsModule } from '../../sending-system/base/base-send-sms/base-send-sms.module';

@Component({
    selector: 'app-send-white-message',
    templateUrl: './send-white-message.component.html',
    styleUrls: ['../../sending-system/base/base-sending-system.component.scss'],
    imports: [BaseFormModule, PhonebookSelectorComponent, BaseSendSmsModule]
})
export class SendWhiteMessageComponent
  extends BaseFormPageComponent
  implements OnInit, OnDestroy
{
  //#region properties
  phonebookStateService = inject(PhonebookStateService);

  formId: string = 'SendWhiteMessageForm';

  model: CreateWhiteSmsCommand = {};
  formPageConfig: FormPageConfig<GetScheduledMessageByIdDto> = {};
  sendSmsConfig: BaseSendSmsConfig;

  title: string = '';
  refreshPhonebook: number = 0;
  privateNumber: string;

  smsCount: number;
  messageCancelText: string = '';

  //#endregion

  //#endregion

  constructor(
    protected currentService: WhiteMessagesService,
    public dialogService: DialogService,
    public utilityService: UtilityService,
    protected translate: TranslateService,
    public dynamicTabService: DynamicTabService,
    public privateNumberService: PrivateNumbersService,
    private tabsDynamicComponent: TabsDynamicComponent
  ) {
    super();
    this.baseCreateGetApiForSend(
      this.currentService,
      'whiteMessagesCreateWhiteSmsGet'
    );
  }

  ngOnInit() {
    try {
      this.model.phonebookRecipients = [];
      super.ngOnInit();
      this.privateNumber = this.formPageConfig?.editData?.senderNumber;
      this.pageVocabs = 'pages.sendWhiteMessage.';
      this.fields = 'pages.sendWhiteMessage.fields.';
      this.configBaseSendSMS();
      this.form.valueChanges
        .pipe(this.basePipeOperators())
        .subscribe((Changes) => {
          this.changeFormStatus();
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  closeThisTab() {
    try {
      const TimeOut = setTimeout(() => {
        this.tabsDynamicComponent.manualCloseTab('sendWhiteMessage');
        clearTimeout(TimeOut);
      }, 50);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  //#region init

  configBaseSendSMS() {
    try {
      this.sendSmsConfig = {
        title: this.pageVocabs + 'title',
        isEdit: this.formPageConfig.isEditMode,
        isShowPageHeader: true,
        isAddSignature: !this.formPageConfig?.isEditMode ? true : false,
        isAddHeader: !this.formPageConfig?.isEditMode ? true : false,
        isShowCampaign: false,
        msgInfoClassList: 'sm:tw-w-1/2 lg:tw-w-5/12 2xl:tw-w-3/12 tw-mt-2',
        receiversClassList: 'sm:tw-w-1/2 lg:tw-w-7/12 2xl:tw-w-5/12 tw-mt-2',
        sendDateTimeClassList: 'sm:tw-w-1/2 lg:tw-w-5/12 2xl:tw-w-4/12 tw-mt-2',
        isShowReceivers: true,
        isShowFastSend: false,
        sendType: SendTypes.Phonebook,
        privateNumberType: 'whiteMessage',
      };
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  initForm() {
    this.form = new FormGroup({});
  }

  changeFormStatus() {
    try {
      // if (this.model.phonebookRecipients?.length === 0)
      //   this.form.setErrors({ require: true })
      // else
      this.form.setErrors(null);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  //#endregion

  //#region Api

  //create
  baseCreateApi(model: CreateWhiteSmsCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .whiteMessagesCreateWhiteSmsPost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe((result) => {
        this.apiNotificationService.notifyMessage({
          result,
          mode: 'matDialog',
        });
        if (result.isSucceed) this.onSuccess();
      });
  }

  //calculations
  whiteMessageCalculationsApi(model: GetWhiteMessageCalculationsQuery) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .whiteMessagesGetWhiteMessageCalculations({ body: model })
      .pipe(
        map((res: CustomResultOfGetWhiteMessageCalculationsDto) => {
          if (res.isSucceed) this.onConfirmation(res?.data);
        }),
        this.basePipeOperators()
      )
      .subscribe();
  }

  getMessageCancelTextApi(senderNumberId: number) {
    this.messageCancelText = '';

    this.currentService
      .whiteMessagesGetWhiteMessageCancelTextByPrivateNumberId({
        body: { privateNumberId: senderNumberId },
      })
      .pipe(this.basePipeOperators())
      .subscribe((messageCancelText) => {
        this.messageCancelText = messageCancelText?.data;
      });
  }

  //#endregion

  //#region phonebook

  getPhonebookRecipients(model: PhoneBookRecipientRequest[]) {
    try {
      this.model.phonebookRecipients = model;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  getGlobalIndex(event: PhonebookGlobalIndex) {
    try {
      if (event.count || event.fromIndex) {
        this.model.fromIndex = event.fromIndex;
        this.model.count = event.count;
      } else {
        this.model.count = null;
        this.model.fromIndex = null;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  onRefreshPhonebook() {
    try {
      this.refreshPhonebook++;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  //#endregion

  getBaseSendSmsModel(baseModel: BaseSendSms) {
    try {
      this.smsCount = baseModel.smsCount;

      this.model.smsBody = baseModel.finalSmsBody;

      if (baseModel.senderNumberId != this.model.senderNumberId) {
        this.model.senderNumberId = baseModel.senderNumberId;
        this.model.phonebookRecipients = [];

        if (this.model.senderNumberId)
          this.getMessageCancelTextApi(this.model.senderNumberId);
        else this.messageCancelText = '';
      }

      //direct
      this.model.sendDateTimeChecked =
        baseModel.sendDateTimeType == SendDateTimeType.DateTime ||
        baseModel.sendDateTimeType == undefined
          ? true
          : false;
      this.model.sendDateTime = baseModel.directSendDateTime;
      // period
      this.model.sendPeriodChecked =
        baseModel.sendDateTimeType == SendDateTimeType.Period ? true : false;
      this.model.periodStart = baseModel.periodicSendStartDateTime;
      this.model.periodEnd = baseModel.periodicSendEndDateTime;
      this.model.periodText = baseModel.gradualPeriodText;
      this.model.periodTypeValue = baseModel.periodTypeValue;
      this.model.isSendWhiteList = baseModel.isSendWhiteList;
      // gradual
      this.model.gradualChecked =
        baseModel.sendDateTimeType == SendDateTimeType.Gradual ? true : false;
      this.model.gradualStart = baseModel.gradualSendDateTime;
      this.model.gradualPageSize = baseModel.gradualPageSize;
      this.model.gradualPeriodText = baseModel.gradualPeriodText;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  onConfirmation(model: GetScheduledMessageCalculationsDto) {
    try {
      this.unSubs();

      let data = {
        model: model,
        smsCount: this.smsCount,
        sendType: SendTypes.Club,
        privateNumber: this.privateNumber,
      };

      const modalResult = this.dialogService.openModal({
        component: SendSmsConfirmationComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((confirm) => {
          if (confirm) this.baseCreateApi(this.model);
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  onSubmit() {
    try {
      if (
        !this.phonebookStateService.checkForEmptyRecipients(
          this.model.phonebookRecipients
        )
      )
        return;
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;

      // calculations
      this.whiteMessageCalculationsApi({
        smsBody: this.model.smsBody,
        senderNumberId: this.model.senderNumberId,
        phonebookRecipients: this.model.phonebookRecipients,
        count: this.model.count,
        fromIndex: this.model.fromIndex,
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  getPrivateNumber(number: string) {
    this.privateNumber = number;
  }

  unSubs() {
    try {
      this.onDestroy$.next();
      this.onDestroy$.complete();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }
}
